import request from '@/utils/request'

export function epmsa210(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa210/epmsa210`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epmsa210Xls(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa210/epmsa210Xls`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  }).then(res => {
    // console.log('epms9063Xls RES', res)

    const binaryString = window.atob(res.body)
    const binaryLen = binaryString.length
    let bytes = new Uint8Array(binaryLen)
    
    for (let i = 0; i < binaryLen; i++) {
      let ascii = binaryString.charCodeAt(i)
      bytes[i] = ascii
    }
    
    const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
    const blobURL = URL.createObjectURL(blob)

    const link = document.createElement('a');
    link.href = blobURL;
    link.download = `General Material Follow Up.xls`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  })
}

